import React from 'react';

import { SVGPropsType } from 'src/types';

function ChartIndicator(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M2 11.2L5.8 7.20001L9.9 9.86668L14 5.20001"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M1 2L15 2" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" />
            <path d="M1 14L15 14" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" />
        </svg>
    );
}

export default ChartIndicator;
